import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from '../app.component';
import { packagerule_returndata } from 'src/types/packagerule_returndata'; 
import { bmxurl, getAccess } from 'src/globals';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { users_returndata } from 'src/types/user_returndata';
import { GlobalService } from '../_services/global.service';
import { BusyService } from '../_services/busy.service';
import { resource } from 'src/types/resource';

@Component({
  selector: 'app-resource',
  templateUrl: './resource.component.html',
  styleUrls: ['./resource.component.css']
})

export class ResourceComponent implements OnInit {
  ListResources: any[];
  bmxurl: string;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  CreateUpdateResponse: any;
  DisabledListResource: any;
  checked: boolean = true;
  isDisabled: boolean = true;
  selectedItems: any;
  httpResponse: any;
  ListResourceGroupNames: any[];

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;

  constructor(
    private http: HttpClient, private appComp: AppComponent, private router: Router, private messageService: MessageService, private globalService: GlobalService, private busyService: BusyService) { 

    }

  onRowReorder(event: any) {
    
    this.busyService.busy();
    // Manually reorder the array based on the drag/drop indices
    const draggedItem = this.ListResources[event.dragIndex];
    this.ListResources.splice(event.dragIndex, 1);
    this.ListResources.splice(event.dropIndex, 0, draggedItem);
    
    this.ListResources.forEach((resource, index) => {
      resource.displayOrder = index;
    });
    
    // Copy the reordered list to a new variable after reordering
    const reorderedResources = [...this.ListResources];

    let reorderPayload : any= [];
    let newOrderList : any = [];

    reorderedResources.forEach((resource) => {
      reorderPayload.push(({
        resourceid: resource.resourceId,
        displayorder: resource.displayOrder
      }));
    });

    newOrderList = {
      venueid: this.VenueID,
      resources: reorderPayload
    }
    

    this.http.post(bmxurl + "ResourceReorder", newOrderList).subscribe(response => {
      this.busyService.idle();
    }, error => {
      this.busyService.idle();
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while reordering Resources, error:' + error.messages[0]});
    });
  }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);

    localStorage.removeItem("screenMemoryBookingss");
    localStorage.removeItem("screenMemoryEvents");
    
    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        if(getAccess("RESOURCES", user)){
          this.AccessAllowed = true;
          this.loadgrid(false);
        }

        this.CompletedLoading = true;

      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });


  }

  toggleDisabled(){
    this.loadgrid(!this.isDisabled);
  }

  toggleShow(passedResource: any){
    this.busyService.busy();
    this.http.put<resource>(bmxurl + "/Resource", passedResource).subscribe(response => {
      this.httpResponse = response
      if (this.httpResponse.succeeded == true) {
        this.busyService.idle();
      }
    }, error => {
      this.busyService.idle();
      this.messageService.add({ severity: 'error', summary: 'Not Saved', detail: error.messages[0] });
    })
  }

  disableData(ResourceID)
  {
    this.http.delete(bmxurl + "Resource/" + this.VenueID + "/" + ResourceID).subscribe(response => {
      this.CreateUpdateResponse = response
      if(this.CreateUpdateResponse.succeeded == true)
      {
        this.messageService.add({severity:'success', summary:'Disabled', detail:'Resource successfully disabled'});
        this.router.navigateByUrl("/resource");

        this.loadgrid(false);
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Not Disabled', detail: this.CreateUpdateResponse.messages[0]});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Disabled', detail: 'An error occurred disabling this Resource'});
    })
  }
  
  loadgrid(showdisabled: boolean)
  {
    this.http.get(bmxurl + "ResourceList/" + this.VenueID + "/" + "/" + showdisabled).subscribe(response => {
      this.ListResources = (response as packagerule_returndata).data;

      if ((response as packagerule_returndata).messages.length > 0)
        {
          (response as packagerule_returndata).messages.forEach(error => {
            this.messageService.add({severity:'warn', summary:'Response Message', detail: error});
          });
        }

    }, error => {
    });
  }

  editData(EditData)
  {
    let ResourceID = EditData;
    this.router.navigateByUrl("/resourceedit/" + ResourceID);
  }

  disableMulti()
  {
    this.selectedItems.forEach(element => {

    this.http.delete(bmxurl + "Resource/" + this.VenueID + "/" + element.ResourceID).subscribe(response => {
      this.CreateUpdateResponse = response
      if(this.CreateUpdateResponse.succeeded)
      {
        this.loadgrid(false);
      } 
    }, error => {
    
    })
    });
    
  }

  
  }

